import { render, staticRenderFns } from "./ProductionList.vue?vue&type=template&id=2013728b&scoped=true"
import script from "./ProductionList.vue?vue&type=script&lang=js"
export * from "./ProductionList.vue?vue&type=script&lang=js"
import style0 from "./ProductionList.vue?vue&type=style&index=0&id=2013728b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2013728b",
  null
  
)

export default component.exports